export const actionTypes = {
  VIEW: 'view',
  UNSAVE: 'unsave',
  APPLY: 'apply'
};
